// 要素を取得
const select1 = document.querySelector('#select1');
const select2Container = document.querySelector('#select2-container');
const select2 = document.querySelector('#select2');
const select3Container = document.querySelector('#select3-container');
const select3 = document.querySelector('#select3');
const alertMessage = document.querySelector('.shop-select-alert');
const confirmAlertMessage = document.querySelector('.shop-select-alert-confirm');
const select1_text_default = "お届け先を選択してください";
const select1_text_home = "自宅（指定の住所）で受け取り";
const select1_text_shop = "店舗で受け取り";
const input_HowToDeliver = document.getElementById("HowToDeliver");
const cartDeliveryDatetime = document.getElementById("cart-delivery-datetime_section_os2");
const appDividerDeliveryDatetimeElement = document.getElementById('app-divider-delivery-datetime');
var appBlockElement;

// ID「delivery-datetime」の隣にあるクラス「shopify-app-block」を持つ要素を取得
// 要素が存在するか確認
if (appDividerDeliveryDatetimeElement) {
  // 次の兄弟要素を取得
  appBlockElement = appDividerDeliveryDatetimeElement.nextElementSibling;
  
  // 次の兄弟要素がクラス「shopify-app-block」を持っているか確認
  if (appBlockElement && appBlockElement.classList.contains('shopify-app-block')) {
    console.log('shopify-app-block 要素が見つかりました:', appBlockElement);
  } else {
    console.log('delivery-datetime 要素の隣に shopify-app-block クラスを持つ要素が見つかりませんでした。');
  }
} else {
  console.log('IDが「delivery-datetime」の要素が見つかりませんでした。');
}

// 都道府県と店舗の関連付けを配列に定義する
const citiesByPrefecture = {
  東京都_1: [
    'お花茶屋店',
    '青戸店',
    '金町店',
    '立石店',
    '小岩店',
    '町屋店',
    '若松町店',
    '阿佐谷パ－ルセンター店',
    '西永福駅前店',
    '方南町店',
    '喜多見店',
    '祖師谷店',
    '経堂店',
    '豪徳寺店',
    '桜新町店',
    '千歳船橋店',
    '三軒茶屋店',
    '尾山台店',
    '用賀大山通り店',
    '綾瀬店',
    '北綾瀬店',
    '竹の塚店',
    '梅島店',
    '池上店',
    '雑色店',
    '雪谷大塚店',
    '西台本店',
    '板橋仲宿店',
    '旗の台店',
    '西日暮里店',
    '巣鴨店',
    '押上店',
    '菊川店',
    '都立大学駅前店',
    '江古田店',
    '富士見台店',
    '石神井公園店',
    '平和台店',
    '氷川台店',
    '練馬店',
  ],
  東京都_2: [
    '矢川店',
    '喜多見本店',
    '昭島店',
    '清瀬店',
    '青梅師岡店',
    '多摩センター店',
    '成瀬店',
    '鶴川東店',
    'キテラタウン調布店',
    '仙川店',
    '高幡不動店',
    '日野駅前店',
    '元八王子店',
    '西八王子店',
    '武蔵野台店',
    '武蔵村山店',
    '福生店',
  ],
  神奈川県: [
    '愛川中津店',
    '久里浜店',
    '北久里浜店',
    '横須賀武山店',
    '希望ヶ丘店',
    'ドン・キホーテ二俣川店',
    '妙蓮寺店',
    '菊名店',
    '大倉山店',
    '大口店',
    '青葉台本店',
    '緑園都市店',
    '鶴見馬場店',
    '井土ヶ谷店',
    '洪福寺店',
    '中山店',
    '長津田店',
    'カエデウォーク長津田店',
    '厚木妻田店',
    'さがみ野店',
    '渋沢店',
    '向ヶ丘たいら店',
    '鷺沼店',
    '鹿島田店',
    '川崎南加瀬店',
    '梶ヶ谷店',
    '溝ノ口店',
    '川崎京町店',
    '川崎大師店',
    '川崎追分店',
    '生田店',
    '宿河原駅前店',
    '向ヶ丘店',
    '武蔵中原店',
    '相模光が丘店',
    '原当麻店',
    '小田急相模原店',
    '小田急相模原南台店',
    '津久井店',
    '足柄開成店',
    '中央林間店',
    '二宮店',
    '湘南台店',
  ],
  千葉県: [
    '旭本店',
    '我孫子店',
    '鴨川店',
    '小見川店',
    '佐原店',
    'もねの里モール店',
    '松戸店',
    '新松戸店',
    '馬橋店',
    '西船橋店',
    '大網店',
    '銚子店',
    '江戸川台店',
    '新柏店',
    '八街店',
    '茂原高師店',
    '茂原東部台店',
    '茂原店',
    'ライフガーデン茂原店',
  ],
  埼玉県: ['小手指台店', '朝霞店'],
  栃木県: ['自治医大店'],
  茨城県: [
    '友部店',
    'フォレストモール常陸太田店',
    'ひたちなか店',
    '荒川沖本店',
    '笠間店',
    '牛久店',
    'ベイシア玉造店',
    '高萩店',
    '小川店',
    '常陸大宮店',
    '神栖本店',
    '水戸けやき台店',
    'フォレストモール石岡店',
    '下館店',
    '鉾田店',
    '北茨城店',
  ],
  山梨県: ['上野原店', '都留店'],
  長野県: [
    '穂高店',
    '伊那ナイスロード店',
    '塩尻店',
    '駒ヶ根店',
    '梓川店',
    '須坂西店',
    '更埴店',
    '大町店',
    '中野店',
    'ベイシア飯山店',
  ],
  兵庫県: ['竜野店', '稲美店', '加古川店', '三木店', '福崎店', '赤穂店'],
  和歌山県: ['和歌山海南店', 'ｵｰｽﾄﾘｰﾄ紀の川井阪店', '有田店', '大浦街道店'],
};

// お届け方法を選択した時の処理
select1.addEventListener('change', () => {
  if (select1.value === select1_text_shop) {
    select2Container.classList.add('active');
  } else {
    select2Container.classList.remove('active');
    select3Container.classList.remove('active');
  }

  if (select1.value !== select1_text_shop ) {
    alertMessage.style.display = 'none';
    confirmAlertMessage.style.display = 'none';
    select2.value = "";
    select3.value = "";
    if(appBlockElement){
      appBlockElement.style.display = 'block';
    }
    // cartDeliveryDatetime.style.display = 'block';
    if (select1.value === '') { 
      select1.style.color = '#999';
      select2.style.color = '#999';
      select3.style.color = '#999';
    } else {
      select1.style.color = '#000';
      select2.style.color = '#999';
      select3.style.color = '#999';
    }
    input_HowToDeliver.value = select1.value;
    // if (select1.value === '') {
    //   // checkbox_Policy.style.visibility = 'hidden';
    //   // checkoutButton.style.visibility = 'hidden';
    //   // checkoutButton_Dynamic.style.visibility = 'hidden';
    //   checkbox_Policy.style.display = 'none';
    //   checkoutButton.style.display = 'none';
    //   checkoutButton_Dynamic.style.display = 'none';
    // } else {
    //   // checkbox_Policy.style.visibility = 'visible';
    //   // checkoutButton.style.visibility = 'visible';
    //   // checkoutButton_Dynamic.style.visibility = 'visible';
    //   checkbox_Policy.style.display = 'flex';
    //   checkoutButton.style.display = 'flex';
    //   checkoutButton_Dynamic.style.display = 'block';
    // }
  } else {
    if(appBlockElement){
      appBlockElement.style.display = 'none';
    }
    // cartDeliveryDatetime.style.display = 'none';
    select1.style.color = '#000';
    select2.style.color = '#999';
    select3.style.color = '#999';
    if (select3.value === '') {
      alertMessage.style.display = 'block';
      confirmAlertMessage.style.display = 'none';
    } else {
      alertMessage.style.display = 'none';
      confirmAlertMessage.style.display = 'block';
    }
    input_HowToDeliver.value = "";
  }

  // if (select1.value !== select1_text_shop) {
  //   input_HowToDeliver.value = select1.value;
  // }
});

// 都道府県を選択した時の処理
select2.addEventListener('change', () => {
  const shopName = select2.value;
  select3.innerHTML = '';
  if (shopName) {
    // select2で選択された都道府県に対応する店舗をselect3に追加する
    const shops = citiesByPrefecture[shopName];
    if (shops) {
      addOptions(select3, shops);
      select3Container.classList.add('active');
    } else {
      select3Container.classList.remove('active');
    }
  } else {
    select3Container.classList.remove('active');
  }
  if (select1.value === '店舗で受け取り' && select3.value === '') {
    alertMessage.style.display = 'block';
    confirmAlertMessage.style.display = 'none';
  } else {
    alertMessage.style.display = 'none';
    confirmAlertMessage.style.display = 'block';
  }

  if (select2.value === '') {
    select2.style.color = '#999';
    select3.style.color = '#999';
  } else {
    select2.style.color = '#000';
    select3.style.color = '#999';
  }

  input_HowToDeliver.value = "";
});

// select3にoptionを追加する関数
const addOptions = (selectElement, options) => {
  for (let i = 0; i < options.length; i++) {
    if (i == 0) {
      const option = document.createElement('option');
      option.text = "選択してください";
      option.value = "";
      selectElement.add(option);
    }
    const option = document.createElement('option');
    option.text = options[i];
    option.value = options[i];
    selectElement.add(option);
  }
};

select3.addEventListener('change', () => {
  if (select3.value === '') {
    alertMessage.style.display = 'block';
    confirmAlertMessage.style.display = 'none';
    select3.style.color = '#999';
  } else {
    alertMessage.style.display = 'none';
    confirmAlertMessage.style.display = 'block';
    select3.style.color = '#000';
  }

  input_HowToDeliver.value = select3.value;
});

// windowのloadイベントを待って初期状態を設定する
window.addEventListener('load', () => {
  // select1要素を取得
  const select1 = document.querySelector('#select1');
  // 初期状態を「お届け先を選択してください」に戻す
  select1.value = '';
  select2.value = '';
  select3.value = '';
  input_HowToDeliver.value = select1_text_home;
});
